<template><div><h1 id="teilnehmer" tabindex="-1"><a class="header-anchor" href="#teilnehmer"><span>Teilnehmer</span></a></h1>
<p>Teilnehmer — Personen, die für eine Veranstaltung angeschrieben worden sind, sich angemeldet oder teilgenommen haben.</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Teilnehmer sind Personen, die mit einer Veranstaltung verknüpft sind. Neben den Status (z. B. &quot;angemeldet&quot;, bezahlt &quot;ja/nein&quot; oder &quot;Warteliste&quot;) können zu den Teilnehmern auch Rollen und Merkmale erfasst werden. Nach einer Teilnahme erhalten diese Personen optional den Personenstatus &quot;T&quot;, der in der Personenmaske angezeigt wird.</p>
<p>Pfad: <code v-pre>Veranstaltungen → Veranstaltungen</code></p>
<h2 id="datenfelder-in-der-teilnehmertabelle" tabindex="-1"><a class="header-anchor" href="#datenfelder-in-der-teilnehmertabelle"><span>Datenfelder in der Teilnehmertabelle</span></a></h2>
<dl>
<dt>Teilnehmer/Name und Adresse</dt>
<dd>
<p>Personen-ID und Adresse des Teilnehmers</p>
</dd>
<dt>Preis</dt>
<dd>
<p>Preis, vorgeschlagen aus dem Basispreis der <a class="link" href="ft.refdata.veranstaltung.html" title="Veranstaltung">Veranstaltung</a> . Der Preis kann überschrieben werden. Der Preis 0.00 kann nur erfasst werden, wenn in der Tabelle der <a class="link" href="ft.refdata.veranstaltungstypen.html" title="Veranstaltungstypen">Veranstaltungstypen</a> die Option &quot;kostenlos&quot; auf &quot;ja&quot; gesetzt ist.</p>
</dd>
<dt>Wartelistenposition</dt>
<dd>
<p>Rang in der Warteliste. Dar Rang wird automatisch gesetzt, kann aber manuell angepasst werden.</p>
</dd>
<dt>Status</dt>
<dd>
<p>Die Auswahl der Status ist abhängig vom &quot;Anzeigetyp&quot; in der Tabelle <a class="link" href="ft.refdata.veranstaltungstypen.html" title="Veranstaltungstypen">Veranstaltungstypen</a> .<br>Der Initalstatus/Vorschlagswert bei der Erfassung ist im Systemparameter &quot;initAnmeldeStat&quot; festgelegt.<br>Status bei Anzeigetyp &quot;Standard&quot;:</p>
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>importiert</td>
<td>Temporärer Status, der z.B. mit einem Import erfasst werden kann. Für diesen Status weren keine Ereignisse erfasst.</td>
</tr>
<tr>
<td>angemeldet</td>
<td>Definitive Anmeldung. Nur Teilnehmer mit diesem Status können fakturiert werden.</td>
</tr>
<tr>
<td>Anmeldung bestätigt</td>
<td>Der Teilnehmer hat sich angemeldet und eine Bestätigung erhalten.</td>
</tr>
<tr>
<td>Storno mit Gebühr</td>
<td>Teilnahme storniert. Es wird/wurde eine Gebühr verrechnet.</td>
</tr>
<tr>
<td>Storno gebührenfrei</td>
<td>Teilnahme storniert. Es wird/wurde keine Gebühr verrechnet.</td>
</tr>
<tr>
<td>Warteliste</td>
<td>Teilnehmer ist auf Warteliste. Dieser Status wird gesetzt, wenn die max. Teilnehmeranzahl überschritten ist. Teilnehmer auf der Warteliste können manuell zu anderen Status verschoben werden.</td>
</tr>
</tbody>
</table>
<p>Status bei Anzeigetyp &quot;Event&quot;:</p>
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>importiert</td>
<td>Temporärer Status, der z.B. mit einem Import erfasst werden kann. Für diesen Status werden keine Ereignisse erfasst.</td>
</tr>
<tr>
<td>Informiert</td>
<td>Vorinformation des Teilnehmers (&quot;Save the Date&quot;).</td>
</tr>
<tr>
<td>Einladung versendet</td>
<td>Es ist eine Einladung an den Teilnehmer verschickt worden.</td>
</tr>
<tr>
<td>Einladung abgesagt</td>
<td>Der Teilnehmer hat aktiv mitgeteilt, dass er nicht teilnehmen wird.</td>
</tr>
<tr>
<td>angemeldet</td>
<td>Der Teilnehmer hat sich angemeldet.</td>
</tr>
<tr>
<td>Anmeldung bestätigt</td>
<td>Der Teilnehmer hat sich angemeldet und eine Bestätigung erhalten.</td>
</tr>
<tr>
<td>nicht erschienen</td>
<td>Der Teilnehmer ist trotz Anmeldung nicht zum Event erschienen (&quot;No-show&quot;).</td>
</tr>
<tr>
<td>Warteliste</td>
<td>Teilnehmer ist auf Warteliste.</td>
</tr>
<tr>
<td>teilgenommen</td>
<td>Der Teilnahmer hat die Veranstaltung besucht. Dieser Status kann, nach Abschluss der Veranstaltung, automatisch gesetzt werden (Hintergrundjob für Funktion &quot;Veranstaltung automatisch abschliessen&quot;).</td>
</tr>
</tbody>
</table>
</dd>
<dt>Teilnehmer</dt>
<dd>
<p>Personen-ID und Adresse des Teilnehmers</p>
</dd>
<dt>Faktura an</dt>
<dd>
<p>Personen-ID und Adresse des Rechnungsempfängers. Bei der Erfassung wird die Adresse des Teilnehmers als Fakturaadresse eingetragen.</p>
</dd>
<dt>Hauptperson</dt>
<dd>
<p>Personen-ID und Adresse des Gruppenvorstandes. Verknüpfung mit einem Gruppenvorstand (über Personen-ID). Dient zur Identifikation/Zusammenfassung von Familien und Gruppen. Damit die Fakturen direkt dem Gruppenvorstand verrechnet werden können, bestehen folgende Optionen:<div class="itemizedlist"><ul class="itemizedlist" style="list-style-type: disc; "><li class="listitem">Hauptperson bei allen Teilnehmern unter &quot;Faktura an&quot; eintragen:<br>Der Vorstand erhält dann pro Teilnehmeradresse eine Rechnung.</li><li class="listitem">Hauptperson mit Gesamtbetrag erfassen, Teilnehmeradressen mit Betrag 0.00:<br>Der Vorstand erhält dann 1 Rechnung mit dem Gesamtbetrag.</li></ul></div></p>
</dd>
<dt>Anmeldedatum</dt>
<dd>
<p>Erfassungsdatum des Teilnehmers. Kann manuell überschrieben werden.</p>
</dd>
<dt>Fakturadatum</dt>
<dd>
<p>Datum der Rechnungsstellung.</p>
</dd>
<dt>Fakturanummer</dt>
<dd>
<p>Zeigt die Fakturanummer an, wenn die Position bereits fakturiert worden ist.</p>
</dd>
<dt>Bezahlt</dt>
<dd>
<p>Status &quot;bezahlt&quot; ja/nein. Wird mit dem Zahlungseingang automatisch gesetzt.</p>
</dd>
<dt>Bemerkungen</dt>
<dd>
<p>Bemerkungen zum Teilnehmer. Die Bemerkungen können auf die Teilnehmerlisten gedruckt werden (Option beim Drucken).<br>Mit der Option &quot;Bemerkungen automatisch löschen nach Veranstaltungsabeschluss&quot; werden die Einträge entfernt, sofern der Job &quot;Veranstaltung automatisch abschliessen&quot;, mit der entsprechenden Parametrisierung, gelaufen ist.</p>
</dd>
</dl>
<h2 id="weitere-datenfelder-im-erfassungsdialog" tabindex="-1"><a class="header-anchor" href="#weitere-datenfelder-im-erfassungsdialog"><span>Weitere Datenfelder im Erfassungsdialog</span></a></h2>
<dl>
<dt>fakturiert?</dt>
<dd>Status &quot;fakturiert&quot; ja/nein. Wird mit der Fakturierung automatisch gesetzt.</dd>
<dt>Zusager</dt>
<dd>Zeigt &quot;ja&quot; an, wenn der Teilnehmer den Personenstatus &quot;Z&quot; besitzt, damit z.B. vergünstigte Teilnahmegbühren erfasst werden können (manuell, nicht automatisch).</dd>
<dt>Alter</dt>
<dd>Automatisch berechnet aus dem Geburtsdatum des Teilnehmers. Es wird das Alter zum Zeitpunkt des Enddatums der Veranstaltung angezeigt. Für die Validierung des Alters (Warnmeldung) wird mit dem Alter am Enddatums der Veranstaltung gerechnet.</dd>
</dl>
<h2 id="zusatzliche-daten-zum-teilnehmer" tabindex="-1"><a class="header-anchor" href="#zusatzliche-daten-zum-teilnehmer"><span>Zusätzliche Daten zum Teilnehmer</span></a></h2>
<dl>
<dt>Dokumente</dt>
<dd><a class="link" href="ft.refdata.dokumente.html" title="Dokumente">Dokumente</a> des Teilnehmers, wie z.B. Rechnungen oder Einladungen.</dd>
<dt>Aktionen</dt>
<dd><a class="link" href="ft.refdata.aktionen.html" title="Aktionen">Aktionen</a> des Teilnehmers, die mit der Veranstaltung verknüpft sind.</dd>
<dt>Rollen</dt>
<dd>Unter den Teilnehmern können Personen, die bestimmte Aufgaben/Funktionen (z.B. Gruppenleiter, Koch, Sanitäter) übernehmen, mit Rollen versehen werden. Pro Person und Veranstaltung können mehrere Rollen eingetragen werden.</dd>
<dt>Merkmale</dt>
<dd>Zu einerm Teilnehmer können beliebige Merkmale erfasst werden. Das Merkmal ist an den Teilnehmer und die Veranstaltung gebunden und wird in der Personenansicht des Teilnehmers nicht angezeigt. Es können nur diejenigen Merkmale genutzt werden, die in der Stammtabelle der Teilnehmermerkmale eingetragen sind.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="storno" tabindex="-1"><a class="header-anchor" href="#storno"><span>Storno</span></a></h3>
<p>Stornierung von Anmeldungen, vor oder nach der Fakturierung/Zahlung. Diese Funktion ist nur bei Veranstaltungen mit Veranstaltungstyp &quot;Standard&quot; nutzbar.</p>
<p>Es gibt 2 Varianten der Stornierung:</p>
<ul>
<li>
<p>Storno mit Gebühr</p>
<p>Der Eintrag eines Restbetrages erfasst den Status &quot;Storno mit Gebühr&quot;. Im Fakturierungslauf werden hierfür spezielle Rechnungen erstellt.</p>
</li>
<li>
<p>Storno gebührenfrei</p>
<p>Wenn der Restbetrag 0.00 bleibt wird nur der Status &quot;Storno gebührenfrei&quot; gesetzt. Der Teilnehmer erhält keine Rechnung.</p>
</li>
</ul>
<p>Der direkte E-Mailversand kann nur ausgelöst werden, wenn die ganze Verarbeitungskette eingerichtet ist. Das Feld &quot;E-Mail schicken&quot; ist deshalb nur editierbar, wenn im Systemparameter &quot;emailVer&quot; das Attribut &quot;storno&quot; eingetragen ist.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.veranstaltung.html" title="Veranstaltung">Veranstaltungen</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.veranstaltungstypen.html" title="Veranstaltungstypen">Veranstaltungstypen</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.veransterinnerungstorno.html" title="Erinnerungen und Stornierungen">Erinnerungen und Stornierungen</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.manbuch.html" title="Manuelle Buchung">Manuelle Buchungen</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.dokumente.html" title="Dokumente">Dokumente</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.aktionen.html" title="Aktionen">Aktionen</RouteLink></p>
</div></template>


